/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:18
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:08:46
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\center\actions.js
 */
const actions = {
}
export default actions